import { TerminKalender } from '@/domain/termine/shared/types';
import { OHNE_KALENDER_ID } from '@/domain/termine/shared/utils/defaultOhneKalender';
import { SortingState } from '@tanstack/react-table';
import useLocalStorageState from 'use-local-storage-state';

export function useKalenderSorting(kalender: TerminKalender[]) {
  const [sorting] = useLocalStorageState<SortingState>(
    'terminKalender_table_sorting',
    { defaultValue: [] },
  );

  const ohneKalender = kalender.find((k) => k.id === OHNE_KALENDER_ID);

  const sortKalender = [
    ...kalender
      .filter((k) => k.id !== OHNE_KALENDER_ID)
      .sort((a, b) => {
        const comparison = a.name.localeCompare(b.name);
        return sorting?.[0]?.desc ? -comparison : comparison;
      }),
    ...(ohneKalender ? [ohneKalender] : []),
  ];

  return sortKalender;
}
